import { render, staticRenderFns } from "./MentalHealthSurvey.vue?vue&type=template&id=064ac16f&scoped=true&"
import script from "./MentalHealthSurvey.vue?vue&type=script&lang=js&"
export * from "./MentalHealthSurvey.vue?vue&type=script&lang=js&"
import style0 from "./MentalHealthSurvey.vue?vue&type=style&index=0&id=064ac16f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064ac16f",
  null
  
)

export default component.exports